<template>
    <div>
        <zm-row>
            <zm-button size="small" plain type="primary" @click="fetchData" class="btn-in-line">Show All</zm-button>
        </zm-row>
        <zm-form inline>
            <zm-form-item>
                <div slot="label">
                    <tip label="Task Id" id="longtask-query-taskId"></tip>
                </div>
                <zm-input size="small" v-model.trim="filter.taskId" class="task-input-in-line" placeholder="taskId"></zm-input>
            </zm-form-item>
            <zm-form-item>
                <div slot="label">
                    <tip label="SubTask Id" id="longtask-query-subTaskId"></tip>
                </div>
                <zm-input size="small" v-model.trim="filter.subTaskId" class="task-input-in-line" placeholder="subTaskId">
                </zm-input>
            </zm-form-item>
            <zm-form-item>
                <div slot="label">
                    <tip label="Clazz" id="longtask-query-clazz"></tip>
                </div>
                <zm-input size="small" v-model.trim="filter.clazz" class="task-input-in-line" placeholder="clazz">
                </zm-input>
            </zm-form-item>
            <zm-form-item>
                <div slot="label">
                    <tip label="Create User" id="longtask-query-createUser"></tip>
                </div>
                <zm-input size="small" v-model.trim="filter.createUser" class="task-input-in-line" placeholder="createUser">
                </zm-input>
            </zm-form-item>
            <zm-form-item>
                <div slot="label">
                    <tip label="Data Key Field" id="longtask-query-dataKeyField"></tip>
                </div>
                <zm-input size="small" v-model.trim="filter.dataKeyField" class="task-input-in-line" placeholder="dataKeyField">
                </zm-input>
            </zm-form-item>
            <zm-form-item label="Status">
                <div slot="label">
                    <tip label="Status" id="longtask-query-states"></tip>
                </div>
                <zm-select size="small" v-model="filter.states" class="task-states-select" collapse-tags multiple :checkbox-options="statusList">
                </zm-select>
            </zm-form-item>
            <zm-button @click="doSearch()" type="icon" icon="zm-icon-search" size="small"></zm-button>
            <zm-dropdown size="small" @command="handleCommand">
                <zm-button type="icon" icon="zm-icon-download" size="small"></zm-button>
                <zm-dropdown-menu slot="dropdown">
                    <zm-dropdown-item command="downloadLongSubTasksResult">Download Long Sub Tasks Result</zm-dropdown-item>
                    <zm-dropdown-item command="downloadUploadTopicResult">Download Upload Topic Result</zm-dropdown-item>
                </zm-dropdown-menu>
            </zm-dropdown>
            <!-- <zm-button @click="downloadLongSubTasksResult()" type="icon" v-if="hasPermission"
                title="batch trigger tasks" icon="zm-icon-download" size="small"></zm-button>
            <zm-button @click="downloadUploadTopicResult()" type="icon" v-if="hasPermission"
                title="batch trigger tasks" icon="zm-icon-download" size="small"></zm-button> -->
        </zm-form>
        <div class="table-container">
            <zm-table :data="list" v-loading="loading" :init-displayed-column="initDisplayedColumn">
                <zm-table-column prop="taskId" label="taskId" show-overflow-tooltip>
                </zm-table-column>
                <zm-table-column prop="subTaskId" label="subTaskId" show-overflow-tooltip>
                </zm-table-column>
                <zm-table-column prop="clazz" label="clazz" show-overflow-tooltip>
                </zm-table-column>
                <zm-table-column prop="status" label="status" show-overflow-tooltip width="120px">
                    <template slot-scope="scope">
                        {{ scope.row.status }}
                        <tip label="" :tips="scope.row.failedReason" v-if="scope.row.failedReason"></tip>
                    </template>
                </zm-table-column>
                <zm-table-column prop="version" label="version" show-overflow-tooltip width="100px">
                </zm-table-column>
                <zm-table-column prop="dataKeyField" label="dataKeyField" show-overflow-tooltip>
                </zm-table-column>
                <zm-table-column prop="createUser" label="createUser" width="120px">
                </zm-table-column>
                <zm-table-column prop="createdTime" label="createdTime" :formatter="setTime" show-overflow-tooltip>
                </zm-table-column>
                <zm-table-column prop="modifiedTime" label="modifiedTime" :formatter="setTime" show-overflow-tooltip>
                </zm-table-column>
                <zm-table-column prop="operate" label="operate" width="190px" v-if="hasPermission">
                    <template slot-scope="scope">
                        <zm-button class="btn-contain" type="icon" title="delete task" icon="zm-icon-delete" @click="deleteLongSubTasks(scope.row.subTaskId)"></zm-button>
                    </template>
                </zm-table-column>
            </zm-table>
            <div style="text-align: center" class="pagination-wrap">
                <zm-pagination @current-change="paginationChange"
                    @size-change="handleSizeChange"
                    :current-page.sync="pageable.page" :page-size="pageable.size"
                    :page-sizes="[10, 20, 50, 100, 500, 1000]"
                    layout="sizes, total, prev, pager, next, jumper"
                    :total="pageable.total">
                </zm-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { listAllLongSubTasks, searchLongSubTasks, deleteLongSubTasks, downloadLongSubTasksResult, downloadUploadTopicResult } from '../../api/longTask'
import tip from 'components/ToolTip/index'
export default {
    name: 'longtask',
    components: {
        tip
    },
    data () {
        return {
            hasPermission: localStorage.role === 'SUPER_ADMIN' || localStorage.role === 'ADMIN',
            initDisplayedColumn: {
                key: 'longtask',
                props: ['status', 'version', 'dataKeyField', 'createUser', 'createdTime', 'modifiedTime', 'operate']
            },
            list: [],
            listBy: 0,
            loading: false,
            parentLoading: false,
            pageable: {
                page: 1,
                size: 10,
                total: 0
            },
            filter: {
                taskId: '',
                subTaskId: '',
                clazz: '',
                createUser: '',
                dataKeyField: '',
                states: []
            },
            searchStatus: '',
            statusList: [
                {
                    value: 'WAIT',
                    label: 'WAIT'
                },
                {
                    value: 'INPROGRESS',
                    label: 'INPROGRESS'
                },
                {
                    value: 'CANCEL',
                    label: 'CANCEL'
                },
                {
                    value: 'FAILED',
                    label: 'FAILED'
                },
                {
                    value: 'SUCCESS',
                    label: 'SUCCESS'
                }
            ]
        }
    },
    created () {
        if (localStorage.params && localStorage.params !== 'undefined' && localStorage.path === this.$route.path) {
            this.filter = JSON.parse(localStorage.params).filter
            this.listBy = JSON.parse(localStorage.params).listBy
            this.pageable.page = JSON.parse(localStorage.params).page
            this.pageable.size = JSON.parse(localStorage.params).size
            if (this.listBy) {
                this.doSearch()
            } else {
                this.fetchData()
            }
        } else {
            this.fetchData()
        }
        localStorage.params = ''
        localStorage.path = this.$route.path
    },
    watch: {
        listBy () {
            this.setURL()
        },
        'pageable.page' () {
            this.setURL()
        },
        'pageable.size' () {
            this.setURL()
        },
        'filter.taskId' () {
            this.setURL()
        },
        'filter.subTaskId' () {
            this.setURL()
        },
        'filter.clazz' () {
            this.setURL()
        },
        'filter.createUser' () {
            this.setURL()
        },
        'filter.dataKeyField' () {
            this.setURL()
        },
        'filter.states' () {
            this.setURL()
        }
    },
    methods: {
        setURL () {
            const { filter, listBy } = this
            const { page, size } = this.pageable
            const data = { path: this.$route.path, filter, listBy, page, size }
            localStorage.params = JSON.stringify(data)
        },
        handleCommand (command) {
            if (command === 'downloadLongSubTasksResult') {
                this.downloadLongSubTasksResult()
            } else if (command === 'downloadUploadTopicResult') {
                this.downloadUploadTopicResult()
            }
        },
        downloadLongSubTasksResult () {
            downloadLongSubTasksResult(this.filter).then((res) => {
                let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                var a = document.createElement('a')
                a.href = URL.createObjectURL(blob)
                a.download = 'longTask_information.xlsx'
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                a.remove()
            })
        },
        downloadUploadTopicResult () {
            downloadUploadTopicResult(this.filter).then((res) => {
                let blob = new Blob([res], { type: 'application/vnd.ms-excel' })
                var a = document.createElement('a')
                a.href = URL.createObjectURL(blob)
                a.download = 'topic_longTask_information.xlsx'
                a.style.display = 'none'
                document.body.appendChild(a)
                a.click()
                a.remove()
            })
        },
        onSort ({ column, prop, order }) {
            const descending = order === 'descending'
            this.list.sort((a, b) => {
                if (a[prop] > b[prop]) {
                    return descending ? -1 : 1
                } else if (a[prop] < b[prop]) {
                    return descending ? 1 : -1
                } else {
                    return 0
                }
            })
        },
        setTime (row, column, cellValue, index) {
            const time = parseInt(cellValue)
            return new Date(time).getUTCFullYear() + '-' + (new Date(time).getUTCMonth() + 1) + '-' + new Date(time).getUTCDate() + ' ' + new Date(time).getUTCHours() + ':' + new Date(time).getUTCMinutes() + ':' + new Date(time).getUTCSeconds()
        },
        doSearch () {
            this.listBy = 1
            this.loading = true
            searchLongSubTasks(this.pageable.page - 1, this.pageable.size, this.filter).then(response => {
                const { content, pageable: { page, size }, total } = response
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        fetchData () {
            this.listBy = 0
            this.loading = true
            listAllLongSubTasks(this.pageable.page - 1, this.pageable.size).then(response => {
                const { content, pageable: { page, size }, total } = response
                this.list = content
                this.pageable.total = total
                this.pageable.page = page + 1
                this.pageable.size = size
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        handleSizeChange (value) {
            this.pageable.size = value
            this.paginationChange()
        },
        paginationChange () {
            if (this.listBy) {
                this.doSearch()
            } else {
                this.fetchData()
            }
        },
        deleteLongSubTasks (subTaskId) {
            this.$confirm('This will permanently delete the task. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                const data = { subTaskId }
                deleteLongSubTasks(data).then(response => {
                    this.loading = false
                    this.fetchData()
                    this.$message({
                        message: 'Delete task success!',
                        type: 'success'
                    })
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.loading = false
                this.$message({
                    type: 'info',
                    message: 'Delete canceled'
                })
            })
        }
    }
}
</script>
<style scoped>
.task-states-select{
    width: 250px;
}
</style>
<style>
.zm-form--inline .zm-form-item {
    margin-top: 5px;
    margin-bottom: 5px;
    vertical-align: baseline;
}
.zm-form--inline .zm-form-item__content {
    line-height: 32px;
}
.task-input-in-line{
    width: calc((100vw - 500px) / 5);
}
.btn-in-line{
    margin: 10px;
}
</style>
